import {makeFetchTransport, makeMultiplexedTransport} from '@sentry/vue';
import type {BrowserOptions} from '@sentry/vue';

/**
 * Feeds errors and transactions to a second Sentry-compatible DSN while the Better Stack migration
 * runs. Anything else, replays and sessions included, falls back to the primary.
 */
export function createDualFeedTransport(
    dsn: string | undefined,
    secondaryDsn: string | undefined
): BrowserOptions['transport'] {
    if (!dsn || !secondaryDsn) {
        return undefined;
    }

    // Replays and sessions are left out: the heaviest envelopes by far, and they answer nothing the
    // error and transaction feeds don't already cover.
    return makeMultiplexedTransport(makeFetchTransport, ({getEvent}) =>
        getEvent(['event', 'transaction']) ? [dsn, secondaryDsn] : []
    );
}
